export const FETCH_DETAILS = 'reconciliationPeriodBonusDetails/FETCH_DETAILS';
